import SearchFilter from './SearchFilter.vue';
import Icon from './Icon.vue';
import ListItem from './ListItem.vue';
import ListFilter from './ListFilter.vue';

const components = [
    SearchFilter,
    Icon,
    ListItem,
    ListFilter
]

const install = (Vue, options) => {
    if (install.installed) return

    components.map(component => {
            Vue.component(component.name, component)
        })
        // Vue.prototype.$global = Global;
        // Vue.prototype.$loading = Loading;
}

if (typeof window !== 'undefined' && window.Vue) {
    install(window.Vue)
}

export default {
    install
}


// WEBPACK FOOTER //
// ./src/components/index.js